import { useMutation, useQueryClient } from '@tanstack/react-query';
import { walletApi, type WithdrawalRequest } from '@/api/wallet-api';

const WALLET_KEY = 'wallet';

export function useWithdraw() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: WithdrawalRequest) => walletApi.requestWithdrawal(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [WALLET_KEY] });
    },
  });
}
